var _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.544145,
    y: 0.562699,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    fill: "#020407",
    fillOpacity: 0.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.544145,
    y: 0.562699,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    stroke: "url(#paint0_linear_706_70361)",
    strokeWidth: 1.07657
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.544145,
    y: 0.562699,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    stroke: "url(#paint1_linear_706_70361)",
    strokeWidth: 1.07657
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_70361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5117 20.5303C28.1158 20.5303 20.5117 28.1335 20.5117 37.5303C20.5117 46.926 28.115 54.5303 37.5117 54.5303C46.9076 54.5303 54.5117 46.927 54.5117 37.5303C54.5117 28.1344 46.9085 20.5303 37.5117 20.5303ZM37.0087 45.487C36.0465 45.487 35.308 44.6814 35.308 43.7639C35.308 42.824 36.0688 42.0409 37.0087 42.0409C37.9486 42.0409 38.7317 42.8241 38.7317 43.764C38.7317 44.6814 37.9709 45.487 37.0087 45.487ZM39.5596 36.7823C38.3289 37.7445 38.3065 38.4158 38.3065 39.5794C38.3065 40.0046 38.0827 40.4969 36.9862 40.4969C36.0687 40.4969 35.7555 40.1612 35.7555 38.9977C35.7555 37.0732 36.6059 36.1557 37.2548 35.5963C37.9932 34.9697 39.2464 34.2761 39.2464 33.0678C39.2464 32.0383 38.3513 31.5461 37.2324 31.5461C34.95 31.5461 35.4423 33.2692 34.2338 33.2692C33.6297 33.2692 32.8912 32.8663 32.8912 31.9937C32.8912 30.7853 34.2786 28.9951 37.2996 28.9951C40.1638 28.9951 42.0659 30.5839 42.0659 32.6873C42.0659 34.7907 40.1638 36.3124 39.5596 36.7823Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_706_70361",
    x1: -8.16079,
    y1: 4.25897,
    x2: 74.7156,
    y2: 75.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024751",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#024751",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_706_70361",
    x1: 89.839,
    y1: 91.9749,
    x2: 2.72807,
    y2: 30.2713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#024751",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_70361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(20.5117 20.5303)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomTruck);
export default __webpack_public_path__ + "static/media/customTruck.b1f8dcfcc60aaa1a6d9ee6e8f4535aa3.svg";
export { ForwardRef as ReactComponent };